/** @prettier */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import NotificationBar from '@surfline/quiver-react/dist/NotificationBar';
import Notification from '@surfline/quiver-react/dist/Notification';
import CTA from '@surfline/quiver-react/dist/SurflinePageContainer/CTA';
import cookie from 'react-cookie';
import userPropType from '@surfline/quiver-react/dist/PropTypes/userPropType';

class NotificationBarController extends Component {
  renderBaseNotification = () => {
    const dismissDuration = 1000 * 60 * 60 * 24 * 8;
    const savedTimestamp = cookie.load('dismissTimestamp');
    const nextPresentationTime =
      savedTimestamp != null ? dismissDuration + parseInt(savedTimestamp, 10) : 0;

    const dismissBannerHandler = () => {
      cookie.save('dismissTimestamp', Date.now(), null);
    };

    return nextPresentationTime < Date.now() ? (
      <Notification
        closable
        type="large"
        level="information"
        onCloseComplete={dismissBannerHandler}
      >
        <CTA className="quiver-notification__tag-line" ctaLocation="upsell bar">
          <span className="quiver-notification__tag-line__full-text">
            Ad-free Cams. Extended Forecasts.
          </span>
          {' START FREE TRIAL.'}
        </CTA>
      </Notification>
    ) : null;
  };

  renderOpenHouseNotification = () => {
    const {
      user,
      openHouse: {
        data: {
          sponsorName,
          banner: { copy },
        },
      },
    } = this.props;

    const trackSignUpClick = () =>
      window.analytics.track('Clicked Link', {
        linkLocation: 'premium open house',
        linkName: 'sign up',
      });

    const trackUpgradeClick = () =>
      window.analytics.track('Clicked Link', {
        linkLocation: 'premium open house',
        linkName: 'upgrade',
      });

    return (
      <Notification type="large" level="information">
        <a
          href={user ? '/upgrade' : '/create-account'}
          className="quiver-notification__tag-line"
          onClick={user ? trackUpgradeClick : trackSignUpClick}
        >
          {user
            ? `Premium access provided by ${sponsorName}. Go Premium to keep ad-free cams and 17-day forecasts`
            : `${copy}. Sign Up`}
        </a>
      </Notification>
    );
  };

  /*
  // Disabling renderGiftCardsNotification since PROMOTE_GIFT_CARDS is not used.

  renderGiftCardsNotification = () => {
    const trackClickedLink = () =>
      window.analytics.track('Clicked Link', {
        linkLocation: 'notification bar',
        linkName: 'gift cards',
        linkUrl: '/gift-cards',
      });

    return (
      <Notification type="large" level="information">
        <a href="/gift-cards" className="quiver-notification__tag-line" onClick={trackClickedLink}>
          <span className="quiver-notification__tag-line__full-text">
            Give the Gift of Surfline Premium.
          </span>
          {' '}
          Digital Gift Cards Now Available
        </a>
      </Notification>
    );
  };
  */
  /*
  renderSessionsNotification = () => {
    const trackClickedLink = () =>
      window.analytics.track('Clicked Link', {
        linkLocation: 'notification bar',
        linkName: 'sessions landing page',
        linkUrl: '/lp/sessions',
      });

    return (
      <Notification type="large" level="information">
        <a href="/lp/sessions" className="quiver-notification__tag-line" onClick={trackClickedLink}>
          Introducing Surfline Sessions
          <span className="quiver-notification__tag-line__full-text">
            {': A New Way to Track, Relive and Share Your Rides.'}
          </span>
        </a>
      </Notification>
    );
  };
 */
  renderPaymentWarningsNotification = () => {
    const { warnings, isPremium } = this.props;
    const computeWarningType = () => {
      const warningTypes = warnings.map(({ type }) => type);
      if (warningTypes.includes('failedPayment')) return 'failedPayment';
      if (warningTypes.includes('invalidZip') && isPremium) return 'invalidZip';
      return null;
    };
    const warningType = computeWarningType();
    let notification =
      'We are unable to renew your membership due to a payment problem. To keep Surfline Premium, ';
    const linkText = 'Please update your payment details.';
    if (warningType === 'invalidZip') {
      notification = 'Make sure you keep Surfline Premium. ';
    }
    return (
      <div>
        {warningType ? (
          <Notification closable type="warning-notification" level="error">
            <span>{notification}</span>
            <a href="/account/subscription#payment-details">{linkText}</a>
          </Notification>
        ) : null}
      </div>
    );
  };

  renderNotification = () => {
    const { isPremium, warnings, slDisableNotificationCTA, openHouse } = this.props;

    if (slDisableNotificationCTA === 'on') return null;

    const showOpenHouse = openHouse.active === true;
    if (warnings.length) {
      return this.renderPaymentWarningsNotification();
    }
    if (isPremium || slDisableNotificationCTA === 'on') return null;

    if (showOpenHouse) {
      return this.renderOpenHouseNotification();
    }

    return this.renderBaseNotification();
  };

  render() {
    return <NotificationBar largeNotification={this.renderNotification()} />;
  }
}

NotificationBarController.propTypes = {
  isPremium: PropTypes.bool.isRequired,
  user: userPropType,
  slDisableNotificationCTA: PropTypes.string,
  openHouse: PropTypes.shape({
    active: PropTypes.bool.isRequired,
    data: PropTypes.shape({
      sponsorName: PropTypes.string.isRequired,
      banner: PropTypes.shape({
        copy: PropTypes.string.isRequired,
        creative: PropTypes.shape({
          '1x': PropTypes.string.isRequired,
          '2x': PropTypes.string,
          '3x': PropTypes.string,
        }).isRequired,
      }),
    }),
  }).isRequired,
  warnings: PropTypes.arrayOf(
    PropTypes.shape({
      subscriptionId: PropTypes.string,
      cardId: PropTypes.string,
      planId: PropTypes.string,
      type: PropTypes.string,
      status: PropTypes.string,
    })
  ),
};

NotificationBarController.defaultProps = {
  user: null,
  slDisableNotificationCTA: 'off',
  warnings: [],
};

export default NotificationBarController;
